import { Box, Divider, IconButton, TextField, Tooltip, Typography } from "@material-ui/core";
import { Fullscreen, Save } from "@material-ui/icons";
import { styled } from "@material-ui/styles";
import { useEffect, useState } from "react";
import axios from "axios";
import { REST_API_END_POINT } from 'src/constants/Defaultvalues'; // adjust if needed
import { debounce } from "lodash";
import { useCallback } from "react"; // 👈 Add this import
import { useSnackbar } from "notistack";
import moment from "moment"; // Make sure to install moment.js if not already

const StickyNote = styled(Box)(({ theme }) => ({
    width: '100%',
    height: '100%',
    padding: '1em',
    fontSize: '14px',
    letterSpacing: '1px',
    position: 'relative',
    backgroundColor: '#FFE16A',
    color: '#000',
    boxShadow: '0px 4px 10px rgba(0,0,0,0.3)',
    overflowWrap: 'break-word',
    fontFamily: `'Loved by the King', cursive`,
    borderRadius: '8px',
    margin: 'auto',

    // Custom scrollbar styling
    '&::-webkit-scrollbar': {
        width: '6px',  // Thin scrollbar width
    },
    '&::-webkit-scrollbar-thumb': {
        background: 'rgba(0, 0, 0, 0.2)',  // Low opacity thumb
        borderRadius: '10px',
    },
    '&::-webkit-scrollbar-track': {
        background: 'rgba(0, 0, 0, 0.05)', // Track color
    },
    '&::before': {
        content: '""',
        background: 'linear-gradient(135deg, rgba(255,255,255,0.9), rgba(255,255,255,0.7))',
        height: '40px',
        width: '30px',
        position: 'absolute',
        left: '50%',
        top: '-20px',
        transform: 'rotate(-3deg) translateX(-50%)',
        borderRadius: '4px',
    },
    '&::after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        right: 0,
        borderWidth: '10px 10px 10px 10px',
        borderStyle: 'solid',
        borderTopColor: '#DDC6C3',
        borderLeftColor: '#DDC6C3',
        borderBottomColor: '#5D576B',
        borderRightColor: '#5D576B',
    },
}));

export default function NoteSticky({ initialContent = "", noteId = null, onFullScreenClick, onRefresh, setOpenStickyDialog, userName, updatedOn, addedOn, updatedName }) {
    console.log('userName', userName)
    const [content, setContent] = useState(initialContent);
    const [height, setHeight] = useState('auto');
    const userSession = JSON.parse(localStorage.getItem('user'));
    const { enqueueSnackbar } = useSnackbar();

    useEffect(() => {
        setContent(initialContent || "");  // 🔥 Always sync with latest content
    }, [initialContent]);

    const handleChange = (event) => {
        const value = event.target.value;
        setContent(value);

        const lineCount = value.split('\n').length;
        const minHeight = 250;
        const dynamicHeight = minHeight + (lineCount > 5 ? (lineCount - 5) * 20 : 0);
        setHeight(`${dynamicHeight}px`);
    };

    const handleSaveSticky = async () => {
        if (content === undefined) return;

        try {
            document.activeElement.blur();
            const isEdit = noteId !== null && noteId !== undefined;
            const endpoint = isEdit ? 'edit-sticky-note' : 'add-sticky-note';

            const payload = isEdit
                ? {
                    id: noteId,
                    sticky_note: content.trim() || null,
                    updated_by: userSession?.user_id
                }
                : {
                    sticky_note: content.trim() || null,
                    added_by: userSession?.user_id
                };

            const response = await axios.post(`${REST_API_END_POINT}tickets/${endpoint}`, payload);

            console.log('Saved successfully');
            enqueueSnackbar('Sticky Note saved successfully!', { variant: 'success' });

            if (onRefresh) onRefresh();
            setOpenStickyDialog(false);

        } catch (error) {
            console.error('Error saving sticky note:', error);
            enqueueSnackbar('Failed to save Sticky Note', { variant: 'error' });
        }
    };

    return (
        <StickyNote sx={{ minHeight: '351px', position: 'relative' }}>
            <Tooltip title="Save Sticky Note" placement="top" arrow>
                <IconButton
                    onClick={handleSaveSticky}
                    sx={{
                        position: 'absolute',
                        bottom: 8,
                        right: 24,
                        backgroundColor: '#4CAF50',
                        color: '#fff',
                        '&:hover': {
                            backgroundColor: '#388E3C',
                        },
                        width: 40,
                        height: 40,
                        zIndex: 999,
                    }}
                >
                    <Save fontSize="small" />
                </IconButton>
            </Tooltip>

            <TextField
                fullWidth
                multiline
                minRows={10}
                variant="standard"
                value={content}
                onChange={handleChange}
                placeholder="Write something....."
                InputProps={{
                    disableUnderline: true,
                    style: {
                        fontFamily: `'Loved by the King', cursive`,
                        fontSize: '14px',
                        color: '#000',
                        padding: '12px',
                    }
                }}
                sx={{
                    height: '395px',
                    overflowY: 'auto',
                }}
            />
            <Divider sx={{ pr: 3, pl: 3, mt: 1.8, borderColor: '#000', }} />
            <Typography
                variant='body2'
                sx={{
                    fontFamily: `'Loved by the King', cursive`,
                    fontSize: '12px',
                    color: '#000',
                    marginTop: '12px',
                    paddingLeft: '8px',
                }}>
                {updatedName ? `Last edited by: ${updatedName}` : `Added by: ${userName}` || 'N/A'}
            </Typography>
            <Typography variant='body2' sx={{ fontFamily: `'Loved by the King', cursive`, fontSize: '12px', color: '#000', mt: '4px', pl: '8px' }}>
                {updatedOn
                    ? `Updated on: ${moment.unix(updatedOn).format('MM-DD-YYYY hh:mm:ss A')}`
                    : addedOn
                        ? `Added on: ${moment.unix(addedOn).format('MM-DD-YYYY hh:mm:ss A')}`
                        : 'N/A'}
            </Typography>
        </StickyNote>
    );
}
